import { Component, Input } from '@angular/core';
import { BreakpointService } from '@libs/index';

export interface ProcessStep {
  step: number;
  icon: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-process-step-item',
  templateUrl: './process-step-item.component.html',
  styleUrls: ['./process-step-item.component.scss'],
})
export class ProcessStepItemComponent {
  @Input() data: ProcessStep;
  @Input() isActive: boolean;
  constructor(public breakpointService: BreakpointService) {}
}
